import React from "react";
import { Radio } from "antd";
import { useHistory } from "react-router-dom";

function TabMenu(props) {
  let history = useHistory();

  const handleMenuChange = (e) => {
    history.push(`/jobs/${props.id}/${e.target.value}`);
  };

  return (
    <div>
      <Radio.Group
        value={props.menu}
        onChange={handleMenuChange}
        style={{ marginBottom: 10 }}
      >
        <Radio.Button value="summary" style={{ marginRight: 5 }}>
          Summary
        </Radio.Button>
        <Radio.Button value="tasks" style={{ marginRight: 5 }}>
          Tasks
        </Radio.Button>
        <Radio.Button value="materials" style={{ marginRight: 5 }}>
          Materials
        </Radio.Button>
        <Radio.Button value="recourses" style={{ marginRight: 5 }}>
          Recourses
        </Radio.Button>
        <Radio.Button value="outcomes" style={{ marginRight: 5 }}>
          Outcomes
        </Radio.Button>
      </Radio.Group>
    </div>
  );
}

export default TabMenu;
